import { basicEntityFromJson, IBasicEntity } from "../../../core/models";
import { IProduct, productFromJson } from "../../product/data/entities";
import { calcCleanWeight, calcTotalPrice } from "../../product/utils";
import { ITransaction, transactionFromJson } from "../../transaction/data/entities";

interface IProductHistoryBase {
  wastePercentBefore: number;
  wastePercentAfter: number;
  dirtyWeightBefore: number;
  dirtyWeightAfter: number;
  cleanWeightBefore: number;
  cleanWeightAfter: number;
  totalPriceBefore: number;
  totalPriceAfter: number;
  priceBefore: number;
  priceAfter: number;
  transaction: ITransaction;
  product: IProduct;
}

export interface IProductHistory extends IProductHistoryBase, IBasicEntity {}

export const productHistoryFromJson = (json: any): IProductHistory => {
  const e: IProductHistory = {
    ...basicEntityFromJson(json),
    wastePercentBefore: parseFloat(json.wastePercentBefore),
    wastePercentAfter: parseFloat(json.wastePercentAfter),
    dirtyWeightBefore: parseFloat(json.dirtyWeightBefore),
    dirtyWeightAfter: parseFloat(json.dirtyWeightAfter),
    cleanWeightBefore: calcCleanWeight({
      dirtyWeight: json.dirtyWeightBefore,
      wastePercent: json.wastePercentBefore,
    }),
    cleanWeightAfter: calcCleanWeight({
      dirtyWeight: json.dirtyWeightAfter,
      wastePercent: json.wastePercentAfter,
    }),
    priceBefore: parseFloat(json.priceBefore),
    priceAfter: parseFloat(json.priceAfter),
    totalPriceBefore: calcTotalPrice({
      dirtyWeight: json.dirtyWeightBefore,
      price: json.priceBefore,
      wastePercent: json.wastePercentBefore,
    }),
    totalPriceAfter: calcTotalPrice({
      dirtyWeight: json.dirtyWeightAfter,
      price: json.priceAfter,
      wastePercent: json.wastePercentAfter,
    }),
    transaction: transactionFromJson(json.transaction),
    product: productFromJson(json.product),
  };

  return e;
};

export const productHistoryToJson = () => {
  return {};
};
